import React from 'react';
import { GiCancel } from "react-icons/gi";

const Failed = () => {
  return (
    <div className='h-48 py-2'>
      <p className="text-[var(--Checkout-text-color)] text-center font-bold mb-4 text-sm">
        Cannot confirm payment
      </p>
      <div className='flex justify-center items-center m-6 p-6'>
        <GiCancel className='text-red-700 text-7xl' />
      </div>
    </div>

  )
}

export default Failed
